export default __webpack_public_path__ + "/dist/images/2884570.png";